import React from "react";
import PropTypes from "prop-types";
import ConnectedRegistrationBackButton from "../ConnectedRegistrationBackButton";

const BackButtonSection = ({ hasClassifications = true, controlId }) =>
    hasClassifications && (
        <div className="col col--12 col--xl-2 back-button-container">
            <ConnectedRegistrationBackButton controlId={controlId} />
        </div>
    );

BackButtonSection.propTypes = {
    hasClassifications: PropTypes.bool.isRequired,
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default BackButtonSection;
